import { _post, _get, _delete } from "./Axios";

export default class UsersApi {
  static get(id = null) {
    if (id == null) {
      return _get("users/");
    } else {
      return _get("users/" + id);
    }
  }
  static getactivity(id = null) {
    return _get("users/" + id + "/logaktivitas");
  }
  static getByKeyword(keyword = "") {
    return _get("users/?keyword=" + keyword);
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("users?" + params);
  }
  static searchOwner(key = null) {
    return _get("users/searchowner?key=" + key);
  }
  static post(data) {
    return _post("users/", data);
  }
  static update(id, data) {
    return _post("users/" + id, data);
  }
  static changePassword(id, data) {
    return _post("users/" + id + "/changepassword", data);
  }
  static delete(id) {
    return _delete("users/" + id);
  }
  static check_token(data) {
    return _post("auth/checktoken/", data);
  }
  static getGroups() {
    return _get("users/groups/");
  }
  static logoutUser(id) {
      return _post("users/logout/" + id);
  }
}
